import React, { useContext } from 'react'
import { isTablet } from 'react-device-detect'
import styled from 'styled-components'
import GenericBackButton from './GenericBackButton'
import AppContext from '../context/appContext'
import GenericIcon from './GenericIcon'
import { useLocation } from 'react-router-dom'

import SwitchToLightThemeIcon from '../assets/REDESIGN_Assets/theme/switch-to-light-theme-icon.svg'
import SwitchToDarkThemeIcon from '../assets/REDESIGN_Assets/theme/switch-to-dark-theme-icon.svg'
import CartLightTheme from '../assets/REDESIGN_Assets/Diet/cart-light-theme.svg'
import Cart from '../assets/REDESIGN_Assets/Diet/diet-cart-icon.svg'

export const MobileTopNavigation = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 5%;
  z-index: 5;

  &.player-view {
    @media (max-width: 1000px) and (orientation: landscape) {
      display: none;
    }
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    width: 100%;
    left: 20px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
    left: 20px;
  }
`

const GenericMobileTopNavigation = ({
  handleClick,
  dietCartClick,
  isPlayerView,
}) => {
  const appContext = useContext(AppContext)
  let location = useLocation()

  const changeTheme = () => {
    if (appContext.appState.theme == 'dark') {
      appContext.updateAppState('theme', 'light')
    } else {
      appContext.updateAppState('theme', 'dark')
    }
  }

  return (
    <MobileTopNavigation className={isPlayerView && 'player-view'}>
      <GenericBackButton
        className="mobile-top-nav"
        theme={appContext.appState.theme}
        style={{}}
        handleClick={handleClick}
      />
      {location.pathname.includes('/dieta') &&
        !location.pathname.includes('lista') &&
        !location.pathname.includes('wybierz') && (
          <GenericIcon
            className="mobile-top-nav"
            backgroundPosition={'center'}
            onClick={dietCartClick ? dietCartClick : null}
            src={appContext.appState.theme == 'dark' ? Cart : CartLightTheme}
            width={isTablet ? '4vw' : '5vw'}
            height={isTablet ? '4vw' : '5vw'}
            margin={'0 0 0 4%'}
          />
        )}
      <GenericIcon
        onClick={changeTheme}
        src={
          appContext.appState.theme == 'dark'
            ? SwitchToLightThemeIcon
            : SwitchToDarkThemeIcon
        }
        width={isTablet ? '2vw' : '5vw'}
        height={isTablet ? '2vw' : '5vw'}
        margin={'0 7% 0 0'}
      />
    </MobileTopNavigation>
  )
}

export default GenericMobileTopNavigation
